import type {
  ISODateType,
  DayOfWeekShort,
  ISODateTimeWithUTCType,
  HourOfDay,
} from '@principle-theorem/shared';

/**
 * Date range contract.
 * `to` is EXCLUSIVE per Ovie API: window is [from, to).
 * Both endpoints must include the practice-local UTC offset per ADR-9.
 */
export interface IOvieHealthDateRange {
  from: ISODateTimeWithUTCType;
  to: ISODateTimeWithUTCType;
}

export interface IOvieHealthTrendPoint {
  date: ISODateType;
  count: number;
}

export interface IOvieHealthCategoryCount<TLabel extends string = string> {
  category: TLabel;
  count: number;
}

export interface IOvieHealthIntentCount {
  intent: string;
  count: number;
}

export interface IOvieHealthReasonCount {
  reason: string;
  count: number;
}

export interface IOvieHealthOutcomeCount {
  outcome: string;
  count: number;
}

export interface IOvieHealthWeekdayDatum {
  day: DayOfWeekShort;
  current: number;
  historical: number;
}

export interface IOvieHealthPeakHourDatum {
  hour: HourOfDay;
  count: number;
}

export interface IOvieHealthSentimentBuckets {
  positive: number;
  neutral: number;
  frustrated: number;
  distressed: number;
}

export interface IOvieHealthSentimentDailyPoint
  extends IOvieHealthSentimentBuckets {
  date: ISODateType;
}
